import { MembersAthletesFiltersServiceService } from 'src/app/members/details-page/members-athletes/services/members-athletes-filters-service.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { CountryCombo, HistoricalComboAthlete } from '../../common-page-components/stores/filters-store/filters-store';
import { combineLatest } from 'rxjs';
import { map, mergeMap, filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
export class FilterAthletesService extends MembersAthletesFiltersServiceService {
    constructor(http_self, router_self) {
        super(http_self, router_self);
        this.http_self = http_self;
        this.router_self = router_self;
        this.countryCombo = new CountryCombo('Country:', 'country-combo', this.http_self, [{ item: { CShort: 'All' }, position: 0 }], 'country', true, true);
        this.activeCombo = new HistoricalComboAthlete('Current:', 'currentcombo', undefined, [{ item: { Name: 'All' }, position: 0 }, { item: { Name: 'Current' }, position: 1 }, { item: { Name: 'Historical' }, position: 2 }]);
        this.filtersType = [
            this.textFilter.filterInfo,
            this.countryCombo.filterInfo,
            this.categoryCombo.filterInfo,
            this.activeCombo.filterInfo
        ];
        this.countryCombo.filterInfo.options.selectMultiple = true;
        this.countryCombo.filterInfo.options.initial_state = true;
        this.countryCombo.filterInfo.options.options_selected_subject.next([]);
    }
    getDataStreamWithFilters() {
        // tslint:disable-next-line:max-line-length
        return super.getDataStreamWithFilters().pipe(mergeMap(([order, text, category, active, country]) => {
            return combineLatest([this.orderValue, this.textFilter.data(),
                this.categoryCombo.comboData,
                this.activeCombo.comboData,
                this.countryCombo.comboData.pipe(filter(a => a != null), map(a => a.NOC))
            ]);
        }));
    }
}
FilterAthletesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FilterAthletesService_Factory() { return new FilterAthletesService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Router)); }, token: FilterAthletesService, providedIn: "root" });
